<template>
  <section class="container" id="create-strategy-page">
    <a-button
      class="back-button"
      type="link"
      aria-label="Close"
      @click="handleCancel"
    >
      <LeftOutlined class="button__icon" />
      <span>Volver</span>
    </a-button>

    <h2 class="container__title">Selecciona los filtros para generar una estrategia</h2>
    <a-form
      class="form"
      layout="vertical"
      ref="formRef"
      id="create-strategy-form"
      :model="formState"
      :rules="rules"
    >
      <custom-scrollbar class="container__body" height="calc(100% - 12px)">
        <div class="card">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="Nombre de estrategia" name="name">
                <a-input v-model:value="formState.name" placeholder="Escribir aquí" />
              </a-form-item>
            </a-col>

            <a-col :span="12">
              <a-form-item label="Tipo de estrategia" name="type_strategy">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  :value="formState.type_strategy"
                  placeholder="Seleccione una estrategia"
                  @change="handleTypeStrategyChange"
                >
                  <a-select-option v-for="item in strategyTypes" :key="item.id">
                    <span>{{ item.name }}</span>
                    <a-tag 
                      v-if="item.action"
                      style="margin-left: 10px"
                      :color="ActionPlanStrategyColor[item.action]">
                      {{ ActionPlanStrategyText[item.action] }}
                    </a-tag>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <div
            class="info-help"
            v-if="seletedStrategy && currentStrategyHelp"
          >
            <p class="info-help__text">
              {{ currentStrategyHelp.text }}
              Conoce más haciendo
              <a :href="currentStrategyHelp.url" target="_blank" rel="noopener noreferrer">click aquí</a>.
            </p>
          </div>
        </div>

        <div class="card--error" v-if="typeStrategy === 6 && isEmailSuspended">
          <CloseCircleFilled class="error__icon" />
          <p class="error__text">
            Su empresa ha sido suspendida para el envío de correos masivos debido a las altas tasas
            de rebotes duros y/o quejas de spam.
          </p>
          <a-button @click="openEmailModalSuspension = true"> Conocer más </a-button>
        </div>

        <div class="container__empty" v-if="!seletedStrategy">
          <p class="message--info">Selecciona el tipo de estrategia que deseas gestionar</p>
          <p class="message--info">para mostrar los campos correspondientes</p>
        </div>

        <div class="card" v-if="formState.type_strategy">
          <a-row :gutter="16">
            <a-col :span="8" v-if="!isTypeBusiness">
              <a-form-item label="Empresa" name="entity">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  :dropdownRender="renderWheelSafeDropdown"
                  v-model:value="formState.entity"
                  placeholder="Seleccione una empresa"
                  @change="handleEntityChange"
                >
                  <a-select-option v-for="item in entities" :key="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Campaña" name="portfolio">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  :dropdownRender="renderWheelSafeDropdown"
                  v-model:value="formState.portfolio"
                  placeholder="Seleccione una campaña"
                  @change="handlePortfolioChange"
                  :disabled="typeStrategy === 6 && isEmailSuspended"
                >
                  <a-select-option
                    v-for="item in portfolios"
                    :key="item.id"
                    :disabled="!item.voip_provider"
                  >
                    {{ item.name }}
                    {{ !item.voip_provider ? " (Sin troncal)" : "" }}
                  </a-select-option>

                  <template #dropdownRender v-if="portfolios.length === 0">
                    <div class="dropdown-default__wrapper">
                      Actualmente, no te encuentras asignado a ninguna campaña de la empresa
                      seleccionada. Puedes
                      <span v-if="hasCampaignsMenu">
                        asignarte desde el
                        <router-link to="/operations/campaigns">módulo de Campañas.</router-link>
                      </span>
                      <span v-else> solicitar a tu supervisor realizar el cambio. </span>
                    </div>
                  </template>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="StrategyType.predictive == typeStrategy">
              <TypeAssignmentPicker
                name="type_assignment"
                label="Tipo de asignación"
                popoverTitle="Tipo de asignación"
                v-model="formState.type_assignment"
                disabled
                :options="[
                  { value: 1, label: 'Aleatorio' },
                  { value: 2, label: 'Por asignación' }
                ]"
              >
              </TypeAssignmentPicker>
            </a-col>
              <a-col :span="8" v-if="typeStrategy === 6">
                <a-form-item name="channel_customer">
                  <template #label>
                    Dirección del remitente

                    <a-popover>
                      <template #content>
                        <div class="info-popover-wrapper">
                          <p>Ingresar dirección del remitente</p>
                        </div>
                      </template>

                      <InfoCircleOutlined style="margin-left: 5px" />
                    </a-popover>
                  </template>
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="selectedEmailOption"
                    placeholder="Seleccionar dirección"
                    :disabled="typeStrategy === 6 && isEmailSuspended"
                    @change="handleEmailOptionChange"
                  >
                    <template v-for="item in emailIdentifiers" :key="item.id">
                      <a-select-option :value="'id:' + item.id">
                        <div class="option">
                          <span>{{ item.associate }}</span>
                          <p>{{ item.alias }}</p>
                        </div>
                      </a-select-option>
                      <a-select-option
                        v-for="alias in getAliasesForChannel(item.id)"
                        :key="'alias-' + alias.email"
                        :value="'alias:' + item.id + ':' + alias.email"
                      >
                        <div class="option">
                          <span>{{ alias.email }}</span>
                          <p>{{ item.alias }} ({{ item.associate }})</p>
                        </div>
                      </a-select-option>
                    </template>
                  </a-select>
                </a-form-item>
              </a-col>
            <a-col :span="8" v-if="typeStrategy === 6">
              <a-form-item name="email_type" label="Tipo de mensaje">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.email_type"
                  placeholder="Seleccionar horario"
                  @change="handleEmailTypeChange"
                  @update:value="getEmailTemplates"
                  :disabled="typeStrategy === 6 && isEmailSuspended"
                >
                  <a-select-option :key="1">Usar plantilla</a-select-option>
                  <a-select-option :key="2">Redactar correo</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="typeStrategy === 6">
              <a-form-item name="email_time" label="Horario de envio">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.email_time"
                  placeholder="Seleccionar horario"
                  @change="handleEmailTimeChange"
                  :disabled="typeStrategy === 6 && isEmailSuspended"
                >
                  <a-select-option :key="1">Elegir de forma manual</a-select-option>
                  <a-select-option :key="2">Programar horario</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="typeStrategy !== 6">
              <a-form-item label="Base" name="base" v-if="user?.customer.enable_bases">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.base"
                  placeholder="Seleccione una base"
                  @change="handleBaseChange"
                >
                  <a-select-option v-for="item in bases" :key="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="8" v-if="![StrategyType.email, StrategyType.predictive].includes(typeStrategy)">
              <TypeAssignmentPicker
                name="type_assignment"
                label="Tipo de asignación"
                popoverTitle="Tipo de asignación"
                v-model="formState.type_assignment"
                :disabled="typeStrategy !== 2"
                :options="[
                  { value: 1, label: 'Aleatorio' },
                  { value: 2, label: 'Por asignación' }
                ]"
              >
              </TypeAssignmentPicker>
              <!-- <a-form-item name="type_assignment">
                <template #label>
                  Tipo de asignación

                  <a-popover title="Tipo de asignación">
                    <template #content>
                      <div class="info-popover-wrapper">
                        <p>
                          <strong>Aleatorio: </strong>
                          Se asignarán llamadas o interacciones de forma aleatoria a los usuarios
                          disponibles.
                        </p>

                        <p>
                          <strong>Por asignación: </strong>
                          Solo caerán llamadas o interacciones a los usuarios de sus contactos
                          asignados.
                        </p>
                      </div>
                    </template>

                    <InfoCircleOutlined style="margin-left: 5px" />
                  </a-popover>
                </template>

                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.type_assignment"
                  :disabled="typeStrategy != 2"
                >
                  <a-select-option :key="1">Aleatorio</a-select-option>
                  <a-select-option :key="2">Por asignación</a-select-option>
                </a-select>
              </a-form-item> -->
            </a-col>
            <a-col :span="8" v-if="typeStrategy !== 6">
              <a-form-item name="type_phone">
                <template #label>
                  <span>
                    Tipo de teléfono
                    <a-tooltip>
                      <template #title>
                        <span>Información </span>
                        <QuestionCircleOutlined />
                      </template>
                    </a-tooltip>
                  </span>
                </template>
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.type_phone"
                  @change="handleTypePhoneChange"
                >
                  <a-select-option :key="PhoneType.all"> Todos </a-select-option>
                  <a-select-option :key="PhoneType.landline"> Fijos </a-select-option>
                  <a-select-option :key="PhoneType.mobile"> Celulares </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8" v-if="typeStrategy === StrategyType.predictive">
              <a-form-item
                name="predictive_time"
                label="Horario de inicio"
                :rules="[{ required: true, message: 'Campo requerido' }]"
              >
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.predictive_time"
                  placeholder="Seleccionar horario"
                  @change="handlePredictiveTimeChange"
                >
                  <a-select-option :key="1">
                    <a-tooltip
                      overlayClassName="white-tooltip"
                      placement="right"
                    >
                      <template #title>
                        Una vez creada la estrategia podrás <br/>
                        decidir cuando ejecutarla presionando el botón iniciar.
                      </template>
                      <div>Iniciar de forma manual</div>
                    </a-tooltip>
                  </a-select-option>
                  <a-select-option :key="2">Programar horario</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <div
            class="warning"
            v-if="formState.type_strategy === StrategyType.predictive && formState.portfolio"
          >
            <ExclamationCircleOutlined class="warning__icon" />
            <p class="warning__text">
              Recuerda que para estrategias de tipo predictivo, debes tener configurado el
              equivalente del tipo de grupo “No contacto” en el apartado de tipificaciones. Puedes
              realizarlo ahora haciendo
              <router-link :to="`/operations/campaigns/${formState.portfolio}`">
                click aquí
              </router-link>
              o al terminar de crear esta estrategia.
            </p>
          </div>
        </div>
        <section v-if="(typeStrategy === 6 && emailTime === 2) || (typeStrategy === StrategyType.predictive && predictiveTime === 2)">
          <div class="card">
            <h4>Programar horario</h4>
            <div class="details">
              Define una fecha y hora específica para que la estrategia se ejecute automáticamente.
            </div>
            <a-row :gutter="16">
              <a-col :span="8">
                <a-form-item
                  name="execution_time"
                  label="Seleccionar fecha"
                  :rules="typeStrategy === StrategyType.predictive ? executionTimeRules : []"
                >
                  <a-date-picker
                    style="width: 100%"
                    v-model:value="formState.execution_time"
                    :format="humanDateFormat"
                    v-bind:item="value"
                    class="picker"
                    placeholder="Seleccionar fecha"
                    :show-today="false"
                    :disabled-date="disabledDate"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item
                  name="execution_time"
                  label="Seleccionar hora"
                  :rules="typeStrategy === StrategyType.predictive ? executionTimeRules : []"
                >
                  <a-time-picker
                    v-model:value="formState.execution_time"
                    v-bind:item="value"
                    placeholder="Seleccionar hora"
                    format="HH:mm"
                    class="picker"
                    style="width: 100%"
                    :disabled-time="() => disabledTime(formState.execution_time)"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </section>
        <section v-if="typeStrategy === 6">
          <div class="card">
            <h4>Asunto</h4>
            <a-form-item label="Línea del asunto" name="subject">
              <a-input
                v-model:value="formState.subject"
                placeholder="Escribir asunto"
                show-count
                :maxlength="120"
                :disabled="typeStrategy === 6 && isEmailSuspended"
              />
            </a-form-item>
            <a-form-item label="Texto de vista previa (opcional)" name="message_preview">
              <a-input
                v-model:value="formState.message_preview"
                placeholder="Escribir vista previa"
                show-count
                :maxlength="150"
                :disabled="typeStrategy === 6 && isEmailSuspended"
              />
            </a-form-item>
            <p>
              Controla el texto de vista previa que aparece en la mayoría de las bandejas de
              entrada.
            </p>
          </div>
        </section>
        <!-- Opciones redactar correo correo masivo -->
        <template v-if="openEmail && formState.email_type === 2">
          <div class="card email">
            <h4>Cuerpo del correo electrónico</h4>
            <p class="message--info">
              Escriba el texto de su correo electrónico.
            </p>
            <div class="editor">
              <EditorComponent v-model="formState.message" />
              <InputActionButtons v-model:files="attachments" @select-emoji="handleAddEmoji" multiple :validatePerType="false" />
            </div>
          </div>
        </template>
        <template v-if="formState.email_type === 1 && openEmail">
          <div class="card">
            <h4>Plantilla de correo</h4>
            <a-row :gutter="16">
              <a-col :span="18">
                <a-form-item label="Selecciona la plantilla de correo" name="template_email">
                  <a-select
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    v-model:value="formState.template_email"
                    placeholder="Seleccionar plantilla"
                    @change="handleEmailTemplateChange"
                    :option-label-prop="'customLabel'"
                  >
                    <a-select-opt-group v-if="emailTemplatesWithParameters.length > 0" label="Plantillas con parámetros">
                      <a-select-option
                        v-for="item in emailTemplatesWithParameters"
                        :key="item.id"
                        :disabled="item.status !== 1"
                        :customLabel="`${item.name} (con parámetros)`"
                      >
                        {{ item.name }} ({{ Number(item?.template_type) === TemplateType.Default
                          ? `${ProductName}`
                          : "HTML" }})
                      </a-select-option>
                    </a-select-opt-group>
                    <a-select-opt-group v-if="emailTemplatesWithoutParameters.length > 0" label="Plantillas sin parámetros">
                      <a-select-option
                        v-for="item in emailTemplatesWithoutParameters"
                        :key="item.id"
                        :disabled="item.status !== 1"
                        :customLabel="`${item.name} (sin parámetros)`"
                      >
                        {{ item.name }} ({{ Number(item?.template_type) === TemplateType.Default
                          ? `${ProductName}`
                          : "HTML" }})
                      </a-select-option>
                    </a-select-opt-group>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-popover v-if="displayEmailTemplate && formState.template_email" arrowPointAtCenter placement="right">
                  <template #content>
                    <iframe
                      :srcdoc="displayEmailTemplate"
                      id="template_email"
                      title="template_email"
                      ref="iframe"
                      style="border: none; width: 700px; height: 500px"
                      @load="scaleIframeContent"
                    ></iframe>
                  </template>
                  <a-button type="link" class="view-template">
                    Previsualiza tu plantilla
                  </a-button>
                </a-popover>
                <div v-else class="view-template-disabled">
                  <a-tooltip title="Selecciona una plantilla para poder visualizarlo">
                    <span>
                      Previsualiza tu plantilla
                      <InfoCircleOutlined />
                    </span>
                  </a-tooltip>
                </div>
              </a-col>
            </a-row>
          </div>
        </template>
        <template v-if="hasParametersValues">
          <div class="card">
            <h4>
              {{
                currentEmailTemplate()?.parameters?.length > 0
                  ? `Plantilla con parámetros: `
                  : `Plantilla sin parámetros`
              }}
              <span class="template_detail">
                {{ currentEmailTemplate()?.name }}
              </span>
            </h4>
            <div v-if="currentEmailTemplate()?.parameters?.length > 0" style="margin-bottom: 20px">
              <a-form-item
                style="margin-bottom: 16px"
                label="Tipo de carga"
              >
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.type_upload"
                  disabled
                >
                  <a-select-option v-for="option in chargesType" :key="option.value">
                    {{ option.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <template-parameters
                v-if="formState.type_upload == TypeCharge.PersonalizedParameters"
                v-model:values="formState.parameters_values"
                hideTitle
                :form="formRef"
                :template="currentEmailTemplate()"
                :portfolioId="formState.portfolio"
                :description="`Personalice los parámetros ingresando un valor manualmente o seleccionando un atributo del contacto. Esto te permite ajustar fácilmente la configuración según tus necesidades específicas.`"
                inStrategy
              />
            </div>
          </div>
        </template>
        <!-- Opciones segun correo masivo -->
        <!-- <div class="container__empty" v-if="!formState.template_email">
          <p class="message--info">Selecciona tu plantilla para continuar con tu importación</p>
          <p class="message--info">de correos y variables (si los tuviera) de la plantilla</p>
        </div> -->
        <div class="container__empty" v-if="typeStrategy === 6 && emailType === 0">
          <p class="message--info">Selecciona los campos para continuar</p>
          <p class="message--info">con la creación de tu estrategia</p>
        </div>
        <client-filters-picker
          :coverage="coverage"
          @coverage="handleCoverageChange"
          v-if="hasFilters"
          :origin="typeStrategy === 6 ? 'email' : null"
          :idCampaign="portfolio"
          :typeStrategy="typeStrategy"
        />

        <custom-filters-picker v-if="hasFilters" />

        <no-contact-picker
          ref="noContactPickerRef"
          v-if="hasFilters && typeStrategy == TypeStrategy.Predictive"
          :idPortfolio="portfolio"
          :portfolioName="portfolioName"
        />

        <a-form-item 
          v-if="hasFilters && [TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(typeStrategy)" 
          name="file_ivr_return"
        >
          <audio-ivr-picker
            :typeStrategy="typeStrategy"
            v-model:audioIvr="formState.file_ivr_return"
          />
        </a-form-item>

        <div class="card" v-if="hasFilters && typeStrategy == TypeStrategy.IvrReturn">
          <h4>Ingresa el número de transferencia de llamada</h4>
          <span style="margin-bottom: 10px">
            Se debe ingresar el mismo número que tu audio menciona para transferir la llamada hacia la cola. Si ingresas un número diferente o tu audio no menciona ninguno, la llamada no se transferirá.
          </span>
          <div class="number-transfer">
            <span>
              <span class="required">*</span>
              Número de transferencia:
              <a-tooltip>
                <template #title>
                  Solo se puede ingresar un número del 0 al 9.
                </template>
                <InfoCircleOutlined style="margin-left: 5px" />
              </a-tooltip>
            </span>
            <a-form-item
              label=""
              name="transfer_number"
            >
              <a-input-number
                v-model:value="formState.transfer_number" 
                min="0"
                max="9"
              />
            </a-form-item>
          </div>
        </div>

        <marking-speed-picker
          v-if="hasFilters && typeStrategy == TypeStrategy.Predictive"
          v-model:value="formState.intensity_level"
        />

        <a-skeleton :loading="!hasFilters && skeletonLoading" active />
      </custom-scrollbar>
    </a-form>

    <div class="container__footer">
      <a-row type="flex" justify="end" align="middle">
        <a-col>
          <div class="container__display">{{ selectedClientsDetected }}</div>
        </a-col>
        <!-- <a-col>
          <div class="container__display">{{ selectedEmailsDetected }}</div>
        </a-col> -->
        <a-col>
          <a-tooltip
            :title="
              disabledForm && (typeStrategy == TypeStrategy.Ivr || typeStrategy == TypeStrategy.IvrReturn) ? 
                  'Se deben completar todos los campos solicitados para generar la estrategia.' : null
            "
          >
            <a-button
              type="primary"
              id="create-strategy-button"
              :disabled="disabledForm && (typeStrategy == TypeStrategy.Ivr || typeStrategy == TypeStrategy.IvrReturn)"
              :loading="loading"
              @click="handleGenerate"
            >
              Generar estrategia
            </a-button>
          </a-tooltip>
        </a-col>
      </a-row>
    </div>
  </section>
  <EmailSuspension v-model:open="openEmailModalSuspension" :customChannelId="customChannelId" />

  <RestrictionChangePlanModal
    :title="actionRestriction == ActionPlanStrategy.Upgrade ? 
      'Realiza un upgrade y accede a todo el poder de Beex.' : 
      'Obtén esta funcionalidad personalizando tu plan.'
    "
    v-model:open="openRestriction"
    :planRequest="planRequest"
    :showAlert="showAlertRestriction"
  >
    <template #description v-if="!showAlertRestriction">
      Tu plan {{ PlanTypeText[plan] }} no incluye esta funcionalidad. <br/>
      Solicita un upgrade y potencia tu ambiente de trabajo. 
      ¡Que tu viaje no se detenga!
    </template>
    <template #body v-else>
      <p>
        Tu plan {{ PlanTypeText[plan] }} no incluye esta funcionalidad. <br/>
        Solicita personalizar tu plan para potenciar tu ambiente de trabajo.
      </p>
      <p>
        {{
          isClientBeexcc 
          ? "Cuenta con nosotros para elevar tu experiencia. Estamos listos para asistirte. ✨"
          : "Aprovecha al máximo todo lo que puedes lograr con BeexCC. ¡Lleva tu experiencia más lejos! ✨"
        }}
      </p>
    </template>
  </RestrictionChangePlanModal>
</template>

<script>
import { fetchAllEntities, fetchPortfolios, fetchAllBases } from "@/app/entities/services";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import ClientFiltersPicker from "@/app/strategies/components/pickers/ClientFiltersPicker.vue";
import CustomFiltersPicker from "@/app/strategies/components/pickers/CustomFiltersPicker.vue";
import AudioIvrPicker from "@/app/strategies/components/pickers/AudioIvrPicker.vue";
import NoContactPicker from "@/app/strategies/components/pickers/NoContactPicker.vue";
import MarkingSpeedPicker from "../components/pickers/MarkingSpeedPicker.vue";
import { StrategyType, PhoneType, StrategyDocs } from "@/app/shared/utils/enums";
import { defineComponent, ref, reactive, toRaw, computed, watch, provide, h, onMounted } from "vue";
import {
  QuestionCircleOutlined,
  LeftOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleFilled,
} from "@ant-design/icons-vue";
import { useStore } from "vuex";
import EditorComponent from "@/app/emails/components/editor/Editor.vue";
import EmailSuspension from "@/app/strategies/components/modals/EmailSuspension.vue";
import { fetchAllChannelsCustomersByPortfolio, fetchSendAsAliases } from "@/app/channels/services";
import { fetchEmailTemplates } from "@/app/workspace/services";
import InputActionButtons from "@/app/shared/components/buttons/InputActionButtons.vue";
import { TypeStrategy } from "@/@types/strategies/modalStrategy";
import dayjs from "dayjs";
import TemplateParameters from "@/app/flows/sequences/components/sections/drawerForms/TemplateParameters.vue";
import { TypeCharge } from "@/app/strategies/utils/enums";
import { TemplateType } from "@/@types/flows/emailTemplates";
import { Modal } from "ant-design-vue";
import { useRouter } from "vue-router";
import { PlanType, PlanTypeStrategy, PlanTypeText } from "@/app/common/types";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import { planConfigServices } from "@/app/common/services/PlanConfigServices";
import { ActionPlanStrategy, ActionPlanStrategyText, ActionPlanStrategyColor } from "@/app/common/utils/enums";
import TypeAssignmentPicker from "../components/pickers/TypeAssignmentPicker.vue";
import { disabledDate, disabledTime } from "@/app/shared/utils/dates";

const PlanSpecial = 5;
const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/operaciones/estrategias`;

export default defineComponent({
  components: {
    CustomScrollbar,
    ClientFiltersPicker,
    CustomFiltersPicker,
    NoContactPicker,
    MarkingSpeedPicker,
    QuestionCircleOutlined,
    InfoCircleOutlined,
    CloseCircleFilled,
    ExclamationCircleOutlined,
    LeftOutlined,
    EditorComponent,
    EmailSuspension,
    InputActionButtons,
    TemplateParameters,
    AudioIvrPicker,
    RestrictionChangePlanModal,
    TypeAssignmentPicker,
  },
  async setup() {
    const formRef = ref();
    const store = useStore();
    const entity = ref(0);
    const isTypeBusiness = computed(() => user.value?.customer?.type_business == 2);
    const user = computed(() => store.getters["getDataUser"]);

    const plan = computed(() => user.value?.change_custom_plan?.plan);
    // const plan = computed(() => 2);
    const isClientBeexcc = computed(() => user.value?.is_beexcc);
    const dataPlan = computed(() => store.getters["getDataPlanDetails"]);
    const havePredictivePlan = computed(() => {
      return dataPlan.value?.configuration?.dial_predictive?.active && 
        dataPlan.value?.configuration?.dial_predictive?.checked;
    });
    const haveIvrPlan = computed(() => {
      return dataPlan.value?.configuration?.ivr_outbound?.active && 
        dataPlan.value?.configuration?.ivr_outbound?.checked;
    });
    const openRestriction = ref(false);
    const planRequest = ref();
    const showAlertRestriction = ref(false);
    const actionRestriction = ref();

    const entites = computed(() => store.getters["getEntityList"]);
    const emailTemplates = ref([]);
    const variablesTotal = ref([]);
    const hasParametersValues = ref(false);
    const displayEmailTemplate = ref("");
    const customChannelId = ref(0);
    const noContactPickerRef = ref();
    const router = useRouter();

    const formState = reactive({
      name: "",
      entity: null,
      portfolio: null,
      base: null,
      type_strategy: null,
      type_assignment: 1,
      type_phone: 3,
      subject: null,
      message_preview: null,
      channel_customer: null,
      send_as_alias_identifier: null,
      email_type: null,
      template_email: null,
      execution_time: null,
      parameters_values: [],
      message: null,
      destination: null,
      email_time: null,
      nc_regenerate: false,
      nc_rounds: 0,
      nc_results: [],
      nc_results_childrens: [],
      type_upload: TypeCharge.PersonalizedParameters,
      file_ivr_return: null,
      transfer_number: null,
      intensity_level: 3,
    });

    provide("formState", formState);

    const executionTimeRules = [
      { required: true, message: "Campo requerido" },
      {
        validator: (_, value) => {
          if (!value) return Promise.resolve();
          if (dayjs(value).startOf('minute').isBefore(dayjs().startOf('minute'))) {
            return Promise.reject("La fecha y hora no deben ser anteriores a la actual");
          }
          return Promise.resolve();
        },
        trigger: "change",
      },
    ];

    const checkValidateNcRegenerate = async () => {
      if (formState.nc_regenerate && formState.nc_results_childrens.length == 0)
        return Promise.reject("Campo requerido");
      if (!formState.nc_regenerate || formState.nc_results_childrens.length > 0)
        return Promise.resolve();
    };

    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      entity: [{ required: true, message: "Campo requerido" }],
      portfolio: [{ required: true, message: "Campo requerido" }],
      base: [],
      type_strategy: [{ required: true, message: "Campo requerido" }],
      type_assignment: [{ required: true, message: "Campo requerido" }],
      type_phone: [{ required: true, message: "Campo requerido" }],
      subject: [{ required: true, message: "Campo requerido" }],
      email_type: [{ required: true, message: "Campo requerido" }],
      email_time: [{ required: true, message: "Campo requerido" }],
      channel_customer: [{ required: true, message: "Campo requerido" }],
      template_email: [{ required: true, message: "Campo requerido" }],
      nc_results_childrens: [{ validator: checkValidateNcRegenerate, trigger: "change" }],
      nc_rounds: [{ required: true, message: "Campo requerido" }],
      file_ivr_return: [{ required: true, message: "" }],
      transfer_number: [
        { required: true, message: "Campo requerido" },
        { pattern: /^[0-9]$/, message: "El valor debe estar entre 0 y 9" },
      ],
    };
    if (user.value) {
      if (user.value.customer.type_business == 2) {
        entity.value = 1;
      }
    }
    const openEmail = ref(false);
    const isEmailSuspended = ref(false);
    const openEmailModalSuspension = ref(false);
    const contactType = ref(1);
    const totalFilters = [];

    watch(user, async (newValue) => {
      if (newValue.customer.type_business == 2) {
        entity.value = 1;
      }
    });

    watch(
      () => formState.type_strategy,
      () => {
        openEmail.value = false;
      }
    );

    const handleAddEmoji = (emoji) => {
      const lastClosingTagIndex = formState.message.lastIndexOf("</p>");

      const inputText = formState.message;

      formState.message =
        inputText.slice(0, lastClosingTagIndex) + emoji + inputText.slice(lastClosingTagIndex);
    };

    const emailTemplatesWithParameters = computed(() => {
      return emailTemplates.value.filter((template) => template.parameters?.length > 0);
    });

    const emailTemplatesWithoutParameters = computed(() => {
      return emailTemplates.value.filter((template) => template.parameters === null);
    });

    const currentStrategyHelp = computed(() => {
      const info = StrategyDocs[formState.type_strategy];
      if (!info) return null;
      return {
        url: `${DOCS_URL}/${info.slug}`,
        text: info.text
      }
    });

    const chargesType = [
      { value: TypeCharge.PersonalizedParameters, label: 'Personaliza los parámetros'},
      { value: TypeCharge.ChargeParameters, label: 'Carga tus correos y parámetros'},
    ];

    const disabledForm = ref(true);

    watch(
      () => formState,
      async () => {
        if (formRef.value) {
          try {
            await formRef.value.validateFields();
            disabledForm.value = false;
          } catch {
            disabledForm.value = true;
          }
        }
      },
      { deep: true }
    );

    const handleCancel = () => {
      if (formState?.name || formState?.type_strategy) {
        Modal.confirm({
          title: "¿Deseas descartar tu progreso realizado?",
          icon: h(ExclamationCircleOutlined),
          content: "Al descartar, no se quedará guardado los datos previamente completados.",
          okText: "Sí, descartar",
          cancelText: "No, seguir completando",
          centered: true,
          onOk() {
            router.push("/strategies");
          },
        });
      } else
        router.push("/strategies");
    };

    return {
      rules,
      formState,
      formRef,
      noContactPickerRef,
      isTypeBusiness,
      entites,
      user,
      StrategyType,
      openEmail,
      isEmailSuspended,
      openEmailModalSuspension,
      contactType,
      emailTemplates,
      variablesTotal,
      hasParametersValues,
      displayEmailTemplate,
      customChannelId,
      totalFilters,
      handleAddEmoji,
      TypeStrategy,
      emailTemplatesWithParameters,
      emailTemplatesWithoutParameters,
      TypeCharge,
      chargesType,
      TemplateType,
      disabledForm,
      handleCancel,
      plan,
      havePredictivePlan,
      PlanType,
      openRestriction,
      PlanTypeText,
      planRequest,
      showAlertRestriction,
      haveIvrPlan,
      ActionPlanStrategy,
      ActionPlanStrategyText,
      ActionPlanStrategyColor,
      PlanSpecial,
      actionRestriction,
      disabledDate,
      disabledTime,
      executionTimeRules,
      currentStrategyHelp,
      StrategyDocs,
    };
  },
  data() {
    return {
      loading: false,
      attachments: [],
      entity: undefined,
      entities: [],
      portfolio: undefined,
      portfolioName: undefined,
      portfolios: [],
      emailIdentifiers: [],
      aliasesByIdentifier: {},
      selectedEmailOption: null,
      base: undefined,
      bases: [],
      typeStrategy: 0,
      coverage: 0,
      type_phone: PhoneType.all,
      PhoneType,
      skeletonLoading: false,
      selectedScheduleTime: true,
      emailTime: 0,
      emailType: 0,
      predictiveTime: 0,
      seletedStrategy: false,
    };
  },
  computed: {
    calculations() {
      const filters = this.$store.getters["getStrategyFilters"];
      console.log(filters, "filters elements");
      return {
        clients: filters?.number_clients,
        phones: filters?.number_phones,
        emails: filters?.number_emails,
        clients_emails: filters?.number_clients_emails,
      };
    },
    selectedClientsDetected() {
      const clients = this.calculations.clients;
      const phones = this.calculations.phones;
      const emails = this.calculations.emails;
      const clients_emails = this.calculations.clients_emails;
      if (emails) {
        return `${clients_emails} contactos/ ${emails} correos`;
      }
      if (typeof phones === "number")
        return `${clients} contactos y ${phones} teléfonos seleccionados`;
      if (typeof clients === "number") return `${clients} contactos seleccionados`;
      return "";
    },
    strategyTypes() {
      const items = [
        { id: StrategyType.predictive, name: "Predictivo" },
        { id: StrategyType.progressive, name: "Progresivo" },
        { id: StrategyType.ivr, name: "IVR" },
        { id: StrategyType.ivrReturn, name: "IVR con retorno" },
        { id: StrategyType.email, name: "Correo masivo" },
        // Hidden SMS for PoC
        // { id: StrategyType.sms, name: "SMS" },
        // { id: StrategyType.whatsapp, name: "WhatsApp" },
      ];
      return items.map((el) => {
        let item = el;
        if (
          (!this.accessPredictive && el?.id == TypeStrategy.Predictive) ||
          (!this.accessProgressive && el?.id == TypeStrategy.Progressive) ||
          (!this.accessIvr && el?.id == TypeStrategy.Ivr) ||
          (!this.accessEmail && el?.id == TypeStrategy.Email)
        ) {
          item = { ...item, action: PlanTypeStrategy[this.plan]?.[el?.id] };
          // if (
          //   el?.id == TypeStrategy.Predictive && this.plan == PlanType.Digital ||
          //   el?.id == TypeStrategy.Ivr && this.plan == PlanType.Digital ||
          //   el?.id == TypeStrategy.Progressive && this.plan == PlanType.Digital

          // )
          //   item = { ...item, action: ActionPlanStrategy.Upgrade };
          // else
          //   item = { ...item, action: ActionPlanStrategy.Personalized };
        }
        return item;
      });

    },
    hasFilters() {
      const filters = this.$store.getters["getStrategyFilters"];
      return !!filters;
    },
    hasCampaignsMenu() {
      const userMenus = this.$store.getters["getDataUser"]?.options_menu || [];

      return userMenus.some((menu) => menu?.items.some((subMenu) => subMenu?.name === "Campañas"));
    },
    accessPredictive() {
      return [PlanType.AllInOne, PlanSpecial].includes(this.plan) || 
        (
          [PlanType.Voice, PlanType.DigitalVoice].includes(this.plan) &&
          this.havePredictivePlan
        )
    },
    accessProgressive() {
      return this.plan != PlanType.Digital
    },
    accessIvr() {
      return [PlanType.AllInOne, PlanSpecial].includes(this.plan) || 
        (
          [PlanType.Voice, PlanType.DigitalVoice].includes(this.plan) &&
          this.haveIvrPlan
        )
    },
    accessEmail() {
      return this.plan != PlanType.Voice
    },
  },
  watch: {
    entites(newValue) {
      if (newValue?.length > 0) {
        if (this.isTypeBusiness) {
          this.formState.entity = this.entities.find((item) => item.is_owner).id;
          this.fetchPortfolios();
        }
      }
    },
    typeStrategy(value) {
      if (value == 2) return;
      this.formState.type_assignment = 1;
    },
    base() {
      this.coverage = 1;
      this.type_phone = PhoneType.all;
      this.formState.type_phone = PhoneType.all;
      this.$store.dispatch("setStrategyFiltersProperties", {
        base: this.base,
        portfolio: this.portfolio,
      });
      this.fetchFilters();
    },
    coverage(value) {
      this.$store.dispatch("setStrategyFiltersProperties", { coverage: value });
      this.fetchFilters();
    },
    type_phone(value) {
      this.$store.dispatch("setStrategyFiltersProperties", {
        type_phone: value,
      });
      this.fetchFilters();
    },
  },
  created() {
    this.clearFilters();
    this.fetchEntities();
    this.$store.dispatch("fetchAllEntities");
  },
  methods: {
    updateTotalFilters() {
      this.totalFilters = this.$store.getters["getStrategyFilters"];
    },
    handleGenerate() {
      this.formRef.validateFields().then(() => {
        console.log(this.formState, "this.formState generate");

        const filters = this.$store.getters["getStrategyFilters"];
        const formData = new FormData();

        formData.append("type_origin", 1);
        formData.append("name", toRaw(this.formState).name);
        formData.append("portfolio", toRaw(this.formState).portfolio);

        if (this.formState.queue) formData.append("queue", toRaw(this.formState).queue);
        if (this.formState.base) formData.append("base", toRaw(this.formState).base);
        formData.append("type_strategy", toRaw(this.formState).type_strategy);
        formData.append("type_assignment", toRaw(this.formState).type_assignment);
        if (this.formState.template_email)
          formData.append("template_email", toRaw(this.formState).template_email);
        if (this.formState.message) formData.append("message", toRaw(this.formState).message);
        if (this.formState.destination && this.typeStrategy !== 6)
          formData.append("destination", toRaw(this.formState).destination);
        if (this.formState.execution_time) {
          const fullDate = dayjs(this.formState.execution_time);
          formData.append("execution_time", fullDate.format("YYYY-MM-DD HH:mm:ss"));
        }
        if (this.formState.channel_customer)
          formData.append("channel_customer", toRaw(this.formState).channel_customer);
        if (this.formState.send_as_alias_identifier)
          formData.append("send_as_alias_identifier", toRaw(this.formState).send_as_alias_identifier);

        //Email
        if (this.typeStrategy === 6) {
          if (this.formState.subject) formData.append("subject", toRaw(this.formState).subject);

          if (Object.entries(this.formState.parameters_values).length !== 0) {
            formData.append("type_upload", toRaw(this.formState).type_upload);
            if (this.formState.type_upload == TypeCharge.PersonalizedParameters)
              formData.append("parameter_values", JSON.stringify(this.formState.parameters_values.map(el => (
                  { 
                    id: el.id,
                    with_attribute: el.has_attribute,
                    attribute: el.attribute,
                    value: el.value,
                    name: el.name,
                    alternative_value: el.alternative_value 
                  }))));
          }

          if (this.formState.email_type === 1 || this.formState.email_type === 2) {
            this.formState.destination = 1;
            if (this.formState.destination)
              formData.append("destination", toRaw(this.formState).destination);
          }
          if (this.formState.email_type === 2 && this.attachments)
            // formData.append("attachments", toRaw(this.attachments));
            this.attachments.forEach((file) => {
              formData.append("attachments", file);
            });
        }

        // Ivr con retorno
        if ([TypeStrategy.IvrReturn, TypeStrategy.Ivr].includes(this.typeStrategy)) {
          if (this.formState.file_ivr_return)
            formData.append("file_ivr", toRaw(this.formState).file_ivr_return);
        }
        if (this.typeStrategy == TypeStrategy.IvrReturn) {
          if (this.formState.transfer_number)
            formData.append("transfer_number", toRaw(this.formState).transfer_number);
        }

        if (this.typeStrategy == TypeStrategy.Predictive) {
          formData.append("nc_regenerate", toRaw(this.formState?.nc_regenerate));
          this.formState?.nc_results_childrens.forEach((el) => {
            formData.append("nc_results", el);
          });
          formData.append("nc_rounds", toRaw(this.formState?.nc_rounds));
          formData.append("intensity_level", toRaw(this.formState?.intensity_level));  
        }

        const data = toRaw(this.formState);
        data.coverage = this.coverage;
        formData.append("coverage", toRaw(this.coverage));
        formData.set("filters", JSON.stringify(filters));

        if (data.type_phone == PhoneType.all) {
          delete data.type_phone;
          formData.delete("type_phone");
        }
        delete data.entity;
        formData.delete("entity");

        console.log(formData, "formData");
        console.log(data, "data");

        this.generateByFilters(formData);
      });
    },
    currentEmailTemplate() {
      return this.emailTemplates.find((item) => item?.id == this.formState.template_email);
    },
    currentChannelCustomer() {
      return this.emailIdentifiers.find((item) => item?.id == this.formState.channel_customer);
    },
    async generateByFilters(data) {
      try {
        this.loading = true;
        const response = await this.$store.dispatch("generateStrategyByFilters", data);
        console.log(response, "response generate strategy");
        if (this.typeStrategy == TypeStrategy.Predictive)
          localStorage.setItem(
            "predictive_scheduled",
            JSON.stringify({
              name: this.formState.name,
              id: response?.strategy?.id,
              automatic: this.formState.execution_time ? true : false,
            })
          );
        this.$router.push("/strategies/");
      } catch (error) {
        const reponseError = error.response?.data
          ? Object.values(error.response?.data)?.join?.(",")
          : undefined;

        const errorMessage = error?.getCleanErrorMessage() || reponseError || "Ha ocurrido un error";

        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    async fetchEntities() {
      const data = await fetchAllEntities();
      this.entities = data.results;
    },
    async fetchPortfolios() {
      const response = await fetchPortfolios("", "", this.formState.entity);
      this.portfolios = response.results;
    },
    async getEmailTemplates() {
      this.formState.template_email = undefined;
      if (!this.formState.email_type) return;
      this.emailTemplates = await fetchEmailTemplates(true, this.formState.portfolio);
    },
    async fetchEmailIdentifiers(portfolioId) {
      this.emailIdentifiers = await fetchAllChannelsCustomersByPortfolio(portfolioId);
      await this.preloadAliasesForAllIdentifiers();
    },
    async preloadAliasesForAllIdentifiers() {
      const identifiers = this.emailIdentifiers || [];
      const results = await Promise.allSettled(
        identifiers.map(async (item) => {
          const data = await fetchSendAsAliases(item.id);
          const list = Array.isArray(data) ? data : (data?.results || []);
          return { id: item.id, aliases: list };
        })
      );
      const aliasMap = {};
      for (const r of results) {
        if (r.status === 'fulfilled') {
          aliasMap[r.value.id] = r.value.aliases;
        }
      }
      this.aliasesByIdentifier = aliasMap;
    },
    getAliasesForChannel(channelCustomerId) {
      const list = [...(this.aliasesByIdentifier[channelCustomerId] || [])];
      const sendAsAlias = this.formState.send_as_alias_identifier;
      const channelCustomer = this.formState.channel_customer;
      
      if (channelCustomer === channelCustomerId && sendAsAlias) {
        const exists = list.some((alias) => alias.email === sendAsAlias);
        if (!exists) {
          list.push({
            id: -1,
            email: sendAsAlias,
          });
        }
      }
      return list;
    },
    async fetchBases() {
      const response = await fetchAllBases(
        "",
        this.formState.entity,
        this.formState.portfolio,
        {},
        "1"
      );
      this.bases = response.results;

      if (!this.user?.customer.enable_bases) {
        this.formState.base = this.bases[0]?.id;
        this.base = this.bases[0]?.id;
      }
    },
    async fetchFilters() {
      this.skeletonLoading = true;
      try {
        await this.$store.dispatch("fetchInitialStrategyFilters", this.formState.type_strategy);
      } catch (error) {
        console.log(error);
      }
      this.skeletonLoading = false;
    },
    async handleEntityChange(value) {
      this.entity = value;

      if (this.entity.email_suspended && typeStrategy === 6) {
        this.isEmailSuspended = true;
      }
      this.portfolio = undefined;
      this.base = undefined;
      this.formState.portfolio = undefined;
      this.formState.base = undefined;
      this.$store.commit("CLEAR_FILTERS");
      await this.fetchPortfolios(value);
    },
    handleEmailTemplateChange() {
      this.formState.parameters_values = [];
      this.hasParametersValues = false;
      const currentTemplate = this.currentEmailTemplate();
      console.log(currentTemplate, "currentTemplate");

      if (currentTemplate) {
        this.displayEmailTemplate = currentTemplate.template;
      }

      if (!currentTemplate || !currentTemplate.parameters) {
        return;
      }
      this.variablesTotal = currentTemplate.parameters;
      console.log(this.variablesTotal, "variablesTotal.value");
      this.variablesTotal.forEach((variable) => {
        this.formState.parameters_values[variable.name] = "";
      });

      if (Object.entries(this.formState.parameters_values).length !== 0) {
        this.hasParametersValues = true;
        console.log(this.hasParametersValues, "this.hasParametersValues");
      }
      // if (variablesTotal.length > 0) {
      //   this.hasParametersValues = true;
      //   console.log(this.hasParametersValues, "this.hasParametersValues");
      // }
    },
    async handlePortfolioChange(value) {
      this.portfolio = value;
      this.portfolioName = this.portfolios.find((el) => el.id == value)?.name;
      this.formState.base = undefined;
      this.formState.channel_customer = undefined;
      this.formState.send_as_alias_identifier = null;
      this.selectedEmailOption = null;
      this.aliasesByIdentifier = {};
      await this.fetchBases(value);
      this.$store.dispatch("fetchSelectedActiveUsers", this.formState.portfolio);
      this.fetchEmailIdentifiers(value);
      this.getEmailTemplates();
    },
    handleBaseChange(value) {
      this.base = value;
    },
    handleTypeStrategyChange(value) {
      this.planRequest = undefined;
      this.actionRestriction = null;
      const itemSelected = this.strategyTypes.find(el => el.id == value);
      if (itemSelected && itemSelected?.action && this.plan != 5) {
        this.actionRestriction = itemSelected?.action;
        if (itemSelected.action == ActionPlanStrategy.Personalized)
          this.showAlertRestriction = true;
        else {
          this.showAlertRestriction = false;
          if (
            value == TypeStrategy.Predictive && this.plan == PlanType.Digital ||
            value == TypeStrategy.Ivr && this.plan == PlanType.Digital ||
            value == TypeStrategy.Progressive && this.plan == PlanType.Digital
          )
            this.planRequest = PlanType.AllInOne;
        }

        this.openRestriction = true;
      } else {
        this.formState.type_strategy = value;
        this.typeStrategy = value;
        this.formState.email_type = undefined;
        this.formState.email_time = undefined;
        this.seletedStrategy = true;
        this.formState.entity = undefined;
        this.formState.portfolio = undefined;
        this.emailTime = 0;
        this.predictiveTime = 0;
        this.$store.commit("SET_FILTERS", null);
        // this.fetchFilters();
        this.formState.file_ivr_return = null;
      }
    },
    handleEmailTimeChange(value) {
      this.emailTime = value;
    },
    handlePredictiveTimeChange(value) {
      this.predictiveTime = value;
      this.formState.execution_time = null;
    },
    handleEmailTypeChange(value) {
      this.emailType = value;
      this.openEmail = true;
    },
    handleEmailOptionChange(val) {
      this.isEmailSuspended = false;
      this.formState.send_as_alias_identifier = null;

      if (!val) {
        this.formState.channel_customer = null;
        this.customChannelId = null;
        return;
      }

      if (val.startsWith('alias:')) {
        const parts = val.split(':');
        // alias:<channelId>:<aliasEmail> — email may contain ":" so rejoin from index 2
        const channelId = parseInt(parts[1]);
        const aliasEmail = parts.slice(2).join(':');
        this.formState.channel_customer = channelId;
        this.formState.send_as_alias_identifier = aliasEmail;
      } else {
        // id:<channelId>
        this.formState.channel_customer = parseInt(val.replace('id:', ''));
      }

      this.customChannelId = this.formState.channel_customer;

      const currentIdentifier = this.currentChannelCustomer();
      if (currentIdentifier?.email_suspended && this.typeStrategy === 6) {
        this.isEmailSuspended = true;
      }
    },
    handleCoverageChange(value) {
      this.coverage = value;
    },
    handleTypePhoneChange(value) {
      this.type_phone = value;
    },
    clearFilters() {
      this.$store.dispatch("setStrategyFiltersState", null);
    },
    scaleIframeContent() {
      const iframe = this.$refs.iframe;
      const scale = 0.7; // Escala el contenido al 80% de su tamaño original
      iframe.contentWindow.document.body.style.zoom = scale;
    },
    renderWheelSafeDropdown({ menuNode }) {
      return h(
        "div",
        {
          onWheel: this.stopDropdownWheel,
        },
        [menuNode]
      );
    },
    stopDropdownWheel(event) {
      event.stopPropagation();
    },
  },
});
</script>

<style lang="sass" scoped>
$height: calc(100vh - #{$header-height} - 62px)

.back-button
  width: fit-content
  padding: 0

.form
  flex: 1 1 auto
  min-height: 0

.container
  min-width: 800px
  max-width: calc(50% + 20px)
  height: 100%
  padding: 20px 20px 0 20px
  display: flex
  flex-direction: column

  &__title
    margin: 12px 0 0 0

  &__subtitle
    padding-bottom: 12px
    border-bottom: $border-normal

  &__body
    flex: auto
    margin: 12px 0 0
    padding-right: 16px

  &__footer
    padding: 12px 20px
    border-top: $border-normal

  &__display
    font-size: 12px
    color: $gray-7
    margin-right: 12px

.dropdown-default__wrapper
  margin: 20px auto
  width: 190px
  text-align: center
  color: $gray-8
  font-size: 12px

.button
  &__icon
    margin-right: 8px

.view-template
  position: absolute
  top: 0
  bottom: 0
  margin: auto
  padding: 0

.view-template-disabled
  display: flex
  align-items: center
  min-height: 100%
  cursor: not-allowed
  color: rgba(0, 0, 0, 0.25)

.card
  padding: 20px 12px 8px 12px
  margin: 12px 0
  border: 1px solid $gray-6
  border-radius: 8px

  &--light
    border: 1px solid #dcdcdc
    color: $gray-7
    padding: 8px 12px
    margin: 4px 0 12px 0
    background-color: rgba(0, 0, 0, 0.02)
  &--error
    border: 1px solid $red-9
    background: $red-1
    padding: 8px 16px
    display: flex
    gap: 8px
    border-radius: 4px
    margin: 12px 0
    .error__text
      margin: 0

.info
  display: flex

  &--text
    font-size: 12px

.info-popover-wrapper
  width: 225px
  color: $gray-8

.warning
  display: flex

  &__icon
    color: $orange-6
    margin-top: 1px
    font-size: 15px

  &__text
    font-size: 12px
    color: $gray-8
    margin-left: 4px
.container__empty
  margin: 0 auto
  border: 1px solid $gray-6
  border-radius: 8px
  height: 200px
  font-size: 12px
  color: #8C8C8C
  padding: 70px 0
  text-align: center

.message--info
  margin-bottom: 0
.emal
  .ant-radio-group
    display: flex
    flex-direction: column
.select-info
  color: $gray-6

.number-transfer
  display: flex
  justify-items: left
  gap: 8px
  span
    margin-top: 6px
.required
  color: $red-7
  margin-right: 2px
.details
  color: #00000073
  margin-bottom: 10px

/* Fondo blanco + borde y sombra suaves */
:global(.white-tooltip .ant-tooltip-inner)
  background: #fff
  color: #1f2937
  border: 1px solid #fff
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12)

/* Flecha del tooltip en blanco */
:global(.white-tooltip .ant-tooltip-arrow::before)
  background: #fff

/* Asegura que el overlay del select no recorte el tooltip */
:global(.ant-select-dropdown)
  overflow: visible

.info-help
  &__text
    color: #000000A6

.option
  p
    font-size: 12px
    color: rgba(0, 0, 0, 0.45)
    margin: 0


</style>
<style>
.editor .ck-content {
  min-height: 150px;
}
.card--error span svg {
  color: #ff4d4f;
}
</style>
